import type { RealtimeTrajectoryProperties } from "mobility-toolbox-js/types";

import type { TrainEventConfig } from "../events/trains";

function isEvent(event: TrainEventConfig): boolean {
  const urlParamTime =
    new URLSearchParams(window.location.search).get("time") ?? Date.now();
  const currentTime =
    typeof urlParamTime === "string"
      ? new Date(urlParamTime).getTime()
      : urlParamTime;
  if (event.startDate && !event.endDate) {
    return currentTime > event.startDate.getTime();
  }
  if (!event.startDate && !event.endDate) {
    return false;
  }
  if (!event.startDate && event.endDate) {
    return currentTime < event.endDate.getTime();
  }
  if (event.startDate && event.endDate) {
    return (
      currentTime > event.startDate.getTime() &&
      currentTime < event.endDate.getTime()
    );
  }
  return false;
}

/**
 * Detect if the current trajectory is the one of a train event.
 */
function isEventTrain(
  trajectory: RealtimeTrajectoryProperties,
  event: TrainEventConfig,
): boolean {
  const urlParamRake = new URLSearchParams(window.location.search).get("rake");

  if (urlParamRake === "all") {
    return true;
  }
  if (isEvent(event)) {
    const { rake: eventRake } = event || {};
    const { original_rake: orig, rake } = trajectory || {};
    const rakeToTest = urlParamRake || eventRake;
    return (
      (!!orig && new RegExp(`^${rakeToTest}$`).test(orig)) ||
      (!!rake && new RegExp(`^${rakeToTest}$`).test(rake)) ||
      (!!rake && new RegExp(`${rakeToTest};`).test(rake)) ||
      (!!rake && new RegExp(`;${rakeToTest}`).test(rake))
    );
  }
  return false;
}

export default isEventTrain;
